import React, { useState, useMemo } from 'react'
import LayoutNavbar from '../commonLayout/layoutNavbar'
import AuctionDetails from '../commonLayout/auctionDetails'
import LotListingHeader from '../commonLayout/lotListingHeader'
import LotSection from '../commonLayout/lotSection'
import PreviewLotSection from '../commonLayout/PreviewLotSection'
import PreviewPagination from '../commonLayout/PreviewPagination'
import { useLocation } from 'react-router-dom'
import config from '../../../../../config'
import { selectFontStyle } from '../../../../../CommonComponent/SelectFontStyle'
import PreviewFooter from '../../../../../CommonComponent/PreviewFooter'

export default function ClassicPreview({auctionData,startHour,startMin,endHour,endMin,endDate,startDate,
    lots = [], totalLots = 0, currentPage = 1, onPageChange, lotsLoading, isSidePanelCollapsed,
    onFaqClick, onTermsClick, onRulesClick}) {
    const path=useLocation();
    const hasRealLots = lots && lots.length > 0;
    const totalPages = Math.ceil(totalLots / 50);
    const [sortOption, setSortOption] = useState('lot_number');
    const [searchTerm, setSearchTerm] = useState('');

    const sortedLots = useMemo(() => {
        if (!hasRealLots) return [];
        let filtered = [...lots];
        if (searchTerm) {
            const lowerSearch = searchTerm.toLowerCase();
            filtered = filtered.filter(lot => 
                (lot.title1 || lot.title || '').toLowerCase().includes(lowerSearch) ||
                (lot.title2 || lot.title_2 || '').toLowerCase().includes(lowerSearch) ||
                (lot.lot_number || '').toString().toLowerCase().includes(lowerSearch)
            );
        }
        return filtered.sort((a, b) => {
            if (sortOption === 'price_low') return (a.starting_price || 0) - (b.starting_price || 0);
            if (sortOption === 'price_high') return (b.starting_price || 0) - (a.starting_price || 0);
            return (a.lot_number || 0) - (b.lot_number || 0);
        });
    }, [lots, sortOption, searchTerm, hasRealLots]);

    return (
        <div 
            className={`md:mt-9 mt-5 md:mx-10 mx-5 w-full overflow-x-hidden bg-[#FFF] 
        rounded-t-lg ${isSidePanelCollapsed ? 'w-full' : 'xl:w-[74%] lg:w-[70%] md:w-[60%]'} 
            max-h-screen overflow-y-auto customScrollbar`}
            style={{backgroundColor: auctionData.content_area['background_color'],color: auctionData.content_area['text_color']}}>
            {/* Main navigation container */}
            <LayoutNavbar auctionData={auctionData}/>
            <div className="border-b py-[13px] pl-[23px] border-[#D4D4D8]">
                <p className="text-[11px] font-medium leading-normal" 
                    style={{fontFamily: selectFontStyle(auctionData.font['hearder_font'])}}>
                    {auctionData.title===''?'Auction title here':auctionData.title}</p>
            </div>
            <div className="sm:px-[5%] px-[15px]">
                {/* <!-- auction contents here --> */}
                <div className="w-full llg:flex pt-10 llg:justify-between">
                    <AuctionDetails auctionData={auctionData} startDate={startDate} 
                        endDate={endDate} 
                        startHour={startHour}
                        startMin={startMin}
                        endHour={endHour}
                        endMin={endMin}
                        totalLots={totalLots}
                    />
                    <div className={`llg:w-[50%] flex h-[350px] llg:h-auto justify-center items-start `}>
                        <div className={`flex justify-center items-center flex-col h-[350px] w-full 
                            ${auctionData.auction_image==='' && 'bg-[#E6E6E6]'} `}>
                            <img id='auction-img' 
                                src={auctionData.auction_image!==''? (auctionData.auction_image.startsWith('blob:') ? 
                                    auctionData.auction_image : `${config.Storage.CDN}${auctionData.auction_image}`)
                                    : "/images/lead-auction-img.png"} 
                                alt="lead-auction-img" loading="lazy" 
                                className={auctionData.auction_image!==''?'w-full h-full':'w-auto h-auto'} />
                            {auctionData.auction_image===''&&
                                <p className="text-[8px] text-[#52525A] pt-2 text-center font-semibold 
                            leading-normal">Lead auction image</p>}
                        </div>
                    </div> 
                    {/* <!-- after adding preview image  --> */}
                    <div className="llg:w-[50%] hidden w-full h-auto">
                        <img src="/images/preview-image.png" alt="img" loading="lazy" />
                    </div>
                </div>
                {/* <!-- terms condition & social media links contents --> */}
                <div className="w-full m-0 flex"  style={{fontFamily: selectFontStyle(auctionData.font['body_font'])}}>
                    <div className="flex justify-center w-[50%] items-center">
                        <p 
                            className={
                                "text-[8px] text-center leading-normal cursor-pointer hover:underline " +
                                "hover:text-[#282828] transition-colors"
                            }
                            onClick={onFaqClick}
                        >
                            FAQs +
                        </p>
                        <p 
                            className={
                                "text-[8px] pl-2 text-center leading-normal cursor-pointer hover:underline " +
                                "hover:text-[#282828] transition-colors"
                            }
                            onClick={onTermsClick}
                        >
                            Terms and Conditions +
                        </p>
                        <p 
                            className={
                                "text-[8px] pl-2 text-center leading-normal cursor-pointer hover:underline " +
                                "hover:text-[#282828] transition-colors"
                            }
                            onClick={onRulesClick}
                        >
                            Auction Rules +
                        </p>
                    </div>
                    {/* <!-- social media link --> */}
                    <div className="flex w-[50%] justify-end items-center">
                        <img src="/images/add-calendar-icon.svg" alt="add-calender-icon" 
                            className="cursor-pointer hover:opacity-70 transition-opacity" loading="lazy" />
                        <img src="/images/share-icon.svg" alt="share-icon" 
                            className="cursor-pointer hover:opacity-70 transition-opacity" loading="lazy" />
                    </div>
                </div>
                {/* <!-- listing content --> */}
                <LotListingHeader 
                    auctionData={auctionData} 
                    totalLots={totalLots} 
                    onSortChange={setSortOption} 
                    onSearchChange={setSearchTerm}/>
            </div>
            {/* <!-- listing-page --> */}
            <div className="border-t mt-3 sm:mb-20 mb-5 xl:px-[70px] lg:px-[50px] px-[20px] w-full border-[#E6E6E6]">
                <div className="flex flex-wrap -mx-5">
                    {hasRealLots ? (
                        sortedLots.map((lot, index) => (
                            <PreviewLotSection key={lot._id || index} lot={lot} index={index} auctionData={auctionData} />
                        ))
                    ) : (
                        [...Array(8)].map((item, index) => (
                            <LotSection key={index} index={index} auctionData={auctionData} />
                        ))
                    )}
                </div>
                {totalLots > 50 && (
                    <PreviewPagination 
                        currentPage={currentPage} 
                        totalPages={totalPages} 
                        onPageChange={onPageChange} 
                    />
                )}
            </div>
            {/* <!-- footer content --> */}
            <PreviewFooter auctionData={auctionData}/>
        </div>
    )
}
